import * as React from 'react';
import { connect } from 'react-redux';
import { setTittle, scrollTop } from '../../helper/formvalidation';
import { ApplicationState } from '../../store/index';
import DashboardNavMenu from '../../components/layout/menu/DashboardNav'
import * as LanguageResourcesStore from '../../store/LanguageResoures';
import { floatingJS, mobnav, seo } from '../../helper/Script';
import * as AccountStore from '../../store/siteaccount/Account';

type PassCodeProps =
	LanguageResourcesStore.LanguageResouresState &  AccountStore.AccountState
	& typeof AccountStore.actionCreators & typeof LanguageResourcesStore.actionCreators
	
var languagecontent: any = "";
var accesscode: any = "";

interface State {}
class PassCode extends React.PureComponent<PassCodeProps, State> {

    public render() {
        return (
            <React.Fragment>
                {this.renderPassCode()}
            </React.Fragment>
        );
	}
	componentDidUpdate(){
		seo(setTittle(languagecontent == "" ? "" : languagecontent['breadcrumb']));
    }
   
	public componentDidMount() {
		this.ensureDataFetched();
		floatingJS()
		mobnav()
		scrollTop();		
	}
	private ensureDataFetched() {
		this.props.getSetting("Enable Kiosk Passcode");
		this.props.getLangResources();		
	}

	public renderPassCode() {
		languagecontent = this.props.LanguageResoures;
		const patientLocalStroage: any = localStorage.getItem('Patient');
		const patient = JSON.parse(patientLocalStroage);
		accesscode = this.props.PassCode.filter((se: any) => se.name == "Enable Kiosk Passcode")[0];
		if (accesscode != undefined) {
			accesscode = this.props.PassCode.filter((se: any) => se.name == "Enable Kiosk Passcode")[0].customizeValue;
			accesscode = accesscode + patient.id;
		}		return (
            <React.Fragment>
				<div className="content">
					<div className="container-fluid">
						<div className="row">
							<DashboardNavMenu />
							<div className="col-md-7 col-lg-8 col-xl-9">
                                <div className="card">
									<div className="card-body">
										<h3>Kiosk Access Code</h3>
										<iframe frameBorder="0" src={accesscode} ></iframe> 
                                    </div>
								</div>
							</div>
						</div>
					</div>

				</div>
            </React.Fragment>
        );
    }
}
export default connect(
	(state: ApplicationState) => ({ ...state.langResources, ...state.account }), // Selects which state properties are merged into the component's props
	({ ...LanguageResourcesStore.actionCreators, ...AccountStore.actionCreators })// Selects which action creators are merged into the component's props
)(PassCode as any);



